import type { SelectOption } from "@/components/Form/Form.types";

export const citizenshipOptions: SelectOption[] = [
    {
        "value": "Afghan",
        "label": "Afghan"
    },
    {
        "value": "Albanian",
        "label": "Albanian"
    },
    {
        "value": "Algerian",
        "label": "Algerian"
    },
    {
        "value": "Andorran",
        "label": "Andorran"
    },
    {
        "value": "Angolan",
        "label": "Angolan"
    },
    {
        "value": "Citizen of Antigua and Barbuda",
        "label": "Citizen of Antigua and Barbuda"
    },
    {
        "value": "Argentine",
        "label": "Argentine"
    },
    {
        "value": "Armenian",
        "label": "Armenian"
    },
    {
        "value": "Australian",
        "label": "Australian"
    },
    {
        "value": "Austrian",
        "label": "Austrian"
    },
    {
        "value": "Azerbaijani",
        "label": "Azerbaijani"
    },
    {
        "value": "Bahraini",
        "label": "Bahraini"
    },
    {
        "value": "Bangladeshi",
        "label": "Bangladeshi"
    },
    {
        "value": "Barbadian",
        "label": "Barbadian"
    },
    {
        "value": "Belarusian",
        "label": "Belarusian"
    },
    {
        "value": "Belgian",
        "label": "Belgian"
    },
    {
        "value": "Belizean",
        "label": "Belizean"
    },
    {
        "value": "Beninese",
        "label": "Beninese"
    },
    {
        "value": "Bhutanese",
        "label": "Bhutanese"
    },
    {
        "value": "Bolivian",
        "label": "Bolivian"
    },
    {
        "value": "Citizen of Bosnia and Herzegovina",
        "label": "Citizen of Bosnia and Herzegovina"
    },
    {
        "value": "Botswanan",
        "label": "Botswanan"
    },
    {
        "value": "Brazilian",
        "label": "Brazilian"
    },
    {
        "value": "Bruneian",
        "label": "Bruneian"
    },
    {
        "value": "Bulgarian",
        "label": "Bulgarian"
    },
    {
        "value": "Burkinan",
        "label": "Burkinan"
    },
    {
        "value": "Burundian",
        "label": "Burundian"
    },
    {
        "value": "Cambodian",
        "label": "Cambodian"
    },
    {
        "value": "Cameroonian",
        "label": "Cameroonian"
    },
    {
        "value": "Canadian",
        "label": "Canadian"
    },
    {
        "value": "Cape Verdean",
        "label": "Cape Verdean"
    },
    {
        "value": "Central African",
        "label": "Central African"
    },
    {
        "value": "Chadian",
        "label": "Chadian"
    },
    {
        "value": "Chilean",
        "label": "Chilean"
    },
    {
        "value": "Chinese",
        "label": "Chinese"
    },
    {
        "value": "Colombian",
        "label": "Colombian"
    },
    {
        "value": "Comoran",
        "label": "Comoran"
    },
    {
        "value": "Congolese (Republic of the Congo)",
        "label": "Congolese (Republic of the Congo)"
    },
    {
        "value": "Congolese (DRC)",
        "label": "Congolese (DRC)"
    },
    {
        "value": "Costa Rican",
        "label": "Costa Rican"
    },
    {
        "value": "Croatian",
        "label": "Croatian"
    },
    {
        "value": "Cuban",
        "label": "Cuban"
    },
    {
        "value": "Cypriot",
        "label": "Cypriot"
    },
    {
        "value": "Czech",
        "label": "Czech"
    },
    {
        "value": "Danish",
        "label": "Danish"
    },
    {
        "value": "Djiboutian",
        "label": "Djiboutian"
    },
    {
        "value": "Dominican",
        "label": "Dominican"
    },
    {
        "value": "Citizen of the Dominican Republic",
        "label": "Citizen of the Dominican Republic"
    },
    {
        "value": "East Timorese",
        "label": "East Timorese"
    },
    {
        "value": "Ecuadorean",
        "label": "Ecuadorean"
    },
    {
        "value": "Egyptian",
        "label": "Egyptian"
    },
    {
        "value": "Salvadorean",
        "label": "Salvadorean"
    },
    {
        "value": "Equatorial Guinean",
        "label": "Equatorial Guinean"
    },
    {
        "value": "Eritrean",
        "label": "Eritrean"
    },
    {
        "value": "Estonian",
        "label": "Estonian"
    },
    {
        "value": "Swazi",
        "label": "Swazi"
    },
    {
        "value": "Ethiopian",
        "label": "Ethiopian"
    },
    {
        "value": "Fijian",
        "label": "Fijian"
    },
    {
        "value": "Finnish",
        "label": "Finnish"
    },
    {
        "value": "French",
        "label": "French"
    },
    {
        "value": "Gabonese",
        "label": "Gabonese"
    },
    {
        "value": "Georgian",
        "label": "Georgian"
    },
    {
        "value": "German",
        "label": "German"
    },
    {
        "value": "Ghanaian",
        "label": "Ghanaian"
    },
    {
        "value": "Greek",
        "label": "Greek"
    },
    {
        "value": "Grenadian",
        "label": "Grenadian"
    },
    {
        "value": "Guatemalan",
        "label": "Guatemalan"
    },
    {
        "value": "Guinean",
        "label": "Guinean"
    },
    {
        "value": "Citizen of Guinea-Bissau",
        "label": "Citizen of Guinea-Bissau"
    },
    {
        "value": "Guyanese",
        "label": "Guyanese"
    },
    {
        "value": "Haitian",
        "label": "Haitian"
    },
    {
        "value": "Honduran",
        "label": "Honduran"
    },
    {
        "value": "Hungarian",
        "label": "Hungarian"
    },
    {
        "value": "Icelandic",
        "label": "Icelandic"
    },
    {
        "value": "Indian",
        "label": "Indian"
    },
    {
        "value": "Indonesian",
        "label": "Indonesian"
    },
    {
        "value": "Iranian",
        "label": "Iranian"
    },
    {
        "value": "Iraqi",
        "label": "Iraqi"
    },
    {
        "value": "Irish",
        "label": "Irish"
    },
    {
        "value": "Israeli",
        "label": "Israeli"
    },
    {
        "value": "Italian",
        "label": "Italian"
    },
    {
        "value": "Ivorian",
        "label": "Ivorian"
    },
    {
        "value": "Jamaican",
        "label": "Jamaican"
    },
    {
        "value": "Japanese",
        "label": "Japanese"
    },
    {
        "value": "Jordanian",
        "label": "Jordanian"
    },
    {
        "value": "Kazakh",
        "label": "Kazakh"
    },
    {
        "value": "Kenyan",
        "label": "Kenyan"
    },
    {
        "value": "Citizen of Kiribati",
        "label": "Citizen of Kiribati"
    },
    {
        "value": "Kosovan",
        "label": "Kosovan"
    },
    {
        "value": "Kuwaiti",
        "label": "Kuwaiti"
    },
    {
        "value": "Kyrgyz",
        "label": "Kyrgyz"
    },
    {
        "value": "Lao",
        "label": "Lao"
    },
    {
        "value": "Latvian",
        "label": "Latvian"
    },
    {
        "value": "Lebanese",
        "label": "Lebanese"
    },
    {
        "value": "Citizen of Lesotho",
        "label": "Citizen of Lesotho"
    },
    {
        "value": "Liberian",
        "label": "Liberian"
    },
    {
        "value": "Libyan",
        "label": "Libyan"
    },
    {
        "value": "Liechtenstein citizen",
        "label": "Liechtenstein citizen"
    },
    {
        "value": "Lithuanian",
        "label": "Lithuanian"
    },
    {
        "value": "Luxembourger",
        "label": "Luxembourger"
    },
    {
        "value": "Citizen of Madagascar",
        "label": "Citizen of Madagascar"
    },
    {
        "value": "Malawian",
        "label": "Malawian"
    },
    {
        "value": "Malaysian",
        "label": "Malaysian"
    },
    {
        "value": "Maldivian",
        "label": "Maldivian"
    },
    {
        "value": "Malian",
        "label": "Malian"
    },
    {
        "value": "Maltese",
        "label": "Maltese"
    },
    {
        "value": "Marshallese",
        "label": "Marshallese"
    },
    {
        "value": "Mauritanian",
        "label": "Mauritanian"
    },
    {
        "value": "Mauritian",
        "label": "Mauritian"
    },
    {
        "value": "Mexican",
        "label": "Mexican"
    },
    {
        "value": "Micronesian",
        "label": "Micronesian"
    },
    {
        "value": "Moldovan",
        "label": "Moldovan"
    },
    {
        "value": "Monegasque",
        "label": "Monegasque"
    },
    {
        "value": "Mongolian",
        "label": "Mongolian"
    },
    {
        "value": "Montenegrin",
        "label": "Montenegrin"
    },
    {
        "value": "Moroccan",
        "label": "Moroccan"
    },
    {
        "value": "Mozambican",
        "label": "Mozambican"
    },
    {
        "value": "Citizen of Myanmar",
        "label": "Citizen of Myanmar"
    },
    {
        "value": "Namibian",
        "label": "Namibian"
    },
    {
        "value": "Nauruan",
        "label": "Nauruan"
    },
    {
        "value": "Nepalese",
        "label": "Nepalese"
    },
    {
        "value": "Dutch",
        "label": "Dutch"
    },
    {
        "value": "New Zealander",
        "label": "New Zealander"
    },
    {
        "value": "Nicaraguan",
        "label": "Nicaraguan"
    },
    {
        "value": "Nigerien",
        "label": "Nigerien"
    },
    {
        "value": "Nigerian",
        "label": "Nigerian"
    },
    {
        "value": "North Korean",
        "label": "North Korean"
    },
    {
        "value": "Macedonian",
        "label": "Macedonian"
    },
    {
        "value": "Norwegian",
        "label": "Norwegian"
    },
    {
        "value": "Omani",
        "label": "Omani"
    },
    {
        "value": "Pakistani",
        "label": "Pakistani"
    },
    {
        "value": "Palauan",
        "label": "Palauan"
    },
    {
        "value": "Palestinian",
        "label": "Palestinian"
    },
    {
        "value": "Panamanian",
        "label": "Panamanian"
    },
    {
        "value": "Papua New Guinean",
        "label": "Papua New Guinean"
    },
    {
        "value": "Paraguayan",
        "label": "Paraguayan"
    },
    {
        "value": "Peruvian",
        "label": "Peruvian"
    },
    {
        "value": "Filipino",
        "label": "Filipino"
    },
    {
        "value": "Polish",
        "label": "Polish"
    },
    {
        "value": "Portuguese",
        "label": "Portuguese"
    },
    {
        "value": "Qatari",
        "label": "Qatari"
    },
    {
        "value": "Romanian",
        "label": "Romanian"
    },
    {
        "value": "Russian",
        "label": "Russian"
    },
    {
        "value": "Rwandan",
        "label": "Rwandan"
    },
    {
        "value": "Citizen of St Christopher (St Kitts) and Nevis",
        "label": "Citizen of St Christopher (St Kitts) and Nevis"
    },
    {
        "value": "St Lucian",
        "label": "St Lucian"
    },
    {
        "value": "Vincentian",
        "label": "Vincentian"
    },
    {
        "value": "Samoan",
        "label": "Samoan"
    },
    {
        "value": "San Marinese",
        "label": "San Marinese"
    },
    {
        "value": "Sao Tomean",
        "label": "Sao Tomean"
    },
    {
        "value": "Saudi Arabian",
        "label": "Saudi Arabian"
    },
    {
        "value": "Senegalese",
        "label": "Senegalese"
    },
    {
        "value": "Serbian",
        "label": "Serbian"
    },
    {
        "value": "Citizen of Seychelles",
        "label": "Citizen of Seychelles"
    },
    {
        "value": "Sierra Leonean",
        "label": "Sierra Leonean"
    },
    {
        "value": "Singaporean",
        "label": "Singaporean"
    },
    {
        "value": "Slovak",
        "label": "Slovak"
    },
    {
        "value": "Slovenian",
        "label": "Slovenian"
    },
    {
        "value": "Solomon Islander",
        "label": "Solomon Islander"
    },
    {
        "value": "Somali",
        "label": "Somali"
    },
    {
        "value": "South African",
        "label": "South African"
    },
    {
        "value": "South Korean",
        "label": "South Korean"
    },
    {
        "value": "South Sudanese",
        "label": "South Sudanese"
    },
    {
        "value": "Spanish",
        "label": "Spanish"
    },
    {
        "value": "Sri Lankan",
        "label": "Sri Lankan"
    },
    {
        "value": "Sudanese",
        "label": "Sudanese"
    },
    {
        "value": "Surinamese",
        "label": "Surinamese"
    },
    {
        "value": "Swedish",
        "label": "Swedish"
    },
    {
        "value": "Swiss",
        "label": "Swiss"
    },
    {
        "value": "Syrian",
        "label": "Syrian"
    },
    {
        "value": "Tajik",
        "label": "Tajik"
    },
    {
        "value": "Tanzanian",
        "label": "Tanzanian"
    },
    {
        "value": "Thai",
        "label": "Thai"
    },
    {
        "value": "Bahamian",
        "label": "Bahamian"
    },
    {
        "value": "Gambian",
        "label": "Gambian"
    },
    {
        "value": "Togolese",
        "label": "Togolese"
    },
    {
        "value": "Tongan",
        "label": "Tongan"
    },
    {
        "value": "Trinidad and Tobago citizen",
        "label": "Trinidad and Tobago citizen"
    },
    {
        "value": "Tunisian",
        "label": "Tunisian"
    },
    {
        "value": "Turk, Turkish",
        "label": "Turk, Turkish"
    },
    {
        "value": "Turkmen",
        "label": "Turkmen"
    },
    {
        "value": "Tuvaluan",
        "label": "Tuvaluan"
    },
    {
        "value": "Ugandan",
        "label": "Ugandan"
    },
    {
        "value": "Ukrainian",
        "label": "Ukrainian"
    },
    {
        "value": "Citizen of the United Arab Emirates",
        "label": "Citizen of the United Arab Emirates"
    },
    {
        "value": "Briton, British",
        "label": "Briton, British"
    },
    {
        "value": "American",
        "label": "American"
    },
    {
        "value": "Uruguayan",
        "label": "Uruguayan"
    },
    {
        "value": "Uzbek",
        "label": "Uzbek"
    },
    {
        "value": "Citizen of Vanuatu",
        "label": "Citizen of Vanuatu"
    },
    {
        "value": "Vatican citizen",
        "label": "Vatican citizen"
    },
    {
        "value": "Venezuelan",
        "label": "Venezuelan"
    },
    {
        "value": "Vietnamese",
        "label": "Vietnamese"
    },
    {
        "value": "Yemeni",
        "label": "Yemeni"
    },
    {
        "value": "Zambian",
        "label": "Zambian"
    },
    {
        "value": "Zimbabwean",
        "label": "Zimbabwean"
    }
].sort((a, b) => {
    if (a.value > b.value) {
        return 1;
    }
    if (a.value < b.value) {
        return -1;
    }
    return 0;
});